import {createApiHandler, takeQuery} from '../../agent';
import types from './types';

const Jobs = {
	getAllJobs: ({axiosConfig, keycloakConfig}) => createApiHandler(axiosConfig, null, null, keycloakConfig).get('/quartz'),
	get: ({axiosConfig, keycloakConfig, group, name}) => createApiHandler(axiosConfig, null, null, keycloakConfig).get(`/quartz/${group}/${name}`),
	trigger: ({axiosConfig, keycloakConfig, group, name}) => createApiHandler(axiosConfig, null, null, keycloakConfig).post(`/quartz/${group}/${name}`),
	pause: ({axiosConfig, keycloakConfig, group, name}) => createApiHandler(axiosConfig, null, null, keycloakConfig).delete(`/quartz/${group}/${name}`),
	resume: ({axiosConfig, keycloakConfig, group, name}) => createApiHandler(axiosConfig, null, null, keycloakConfig).put(`/quartz/${group}/${name}`)
};

const jobsSagas = [
	takeQuery(types.GET_ALL_JOBS, Jobs.getAllJobs),
	takeQuery(types.GET, Jobs.get),
	takeQuery(types.TRIGGER, Jobs.trigger),
	takeQuery(types.RESUME, Jobs.resume),
	takeQuery(types.STOP, Jobs.pause)
];

export default jobsSagas;
